<template>
    <div>
        <Toolbar>
            <!-- LEFT -->
            <BackButton :to="__('navigation.dashboard')" :href="$route('dashboard')"/>

        </Toolbar>
        <Card>
            <div>
                <div :class="{
                  'card card-custom ribbon ribbon-clip ribbon-left':isActive,
                  'card card-custom':!isActive
                }">

                    <div v-if="isActive" class="ribbon-target" style="top: 15px; height: 45px; cursor: pointer;" data-toggle="collapse" data-target="#settings">
                        <span class="ribbon-inner bg-success"></span><i class="fa fa-cog"></i>
                    </div>

                    <div class="card-header">
                        <div class="card-title">
                            <h3 class="card-label">{{ __('stock-upload.title') }}</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="mb-4">{{ __('stock-upload.description') }}</div>
                        <div class="alert alert-custom alert-light-warning mb-4">
                            <div class="alert-icon">
                                <i class="fa fa-exclamation-triangle"></i>
                            </div>
                            <div class="alert-text">{{ __('stock-upload.warning') }}</div>
                        </div>
                        <div :class="{'collapse' : isActive}" id="settings">
                            <StockSettings
                                :stores="stores"
                                :connectors="connectors"
                            ></StockSettings>
                        </div>

                        <UploadStocks
                            v-show="isActive"
                            :stores="stores"
                            :connectors="connectors"
                        ></UploadStocks>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
import BackButton from "@components/BackButton";
import Card from '@components/Cards/Card'
import Toolbar from '@components/Toolbar';
import ToolbarLink from '@components/ToolbarLink';
import UploadStocks from '@components/Stock/UploadStocks';
import StockSettings from '@components/Stock/StockSettings';
export default {
    components: {Toolbar, ToolbarLink, Card, BackButton, UploadStocks, StockSettings},
    props: {
        isActive: Boolean,
        stores: Array,
        connectors: Array
    },
}
</script>
